module.exports = __webpack_public_path__ + "static/media/Message-notification.836cd19e.mp3";